
/* ============================================================================
FILE: po-katupirsia9-souffle-d-or-texts-fr-en-es-20260326.js
MODE: protected trilingual with FR / EN / ES buttons + lexicon locking
API:  window.PoKatupirsia9SouffleDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='souffle_d_or']
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_SOUFFLE_D_OR_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_SOUFFLE_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='souffle_d_or']";
  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Souffle_d_or_conceptuel.png?v=1773259117";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Souffle_d_or_fonctionnel.png?v=1773259118";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "";
    }catch(e){ return ""; }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "FR";
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (el) el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.textContent = clampStr(item);
      el.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    (blocks || []).forEach(function(b){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr((b || {}).head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr((b || {}).text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    });
  }

  var CONTENT = {
    FR: {
      title: "Souffle d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Principes matriciels, respiration cosmique et synthèse du φ vivant)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Principe unificateur : respiration cosmique où φ devient battement du réel.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> est donné, dans <em>Katûpirsia&nbsp;9</em>, comme principe matriciel du système doré. Sa fonction posœnnoïale est formulée avec netteté : « principe unificateur : respiration cosmique où φ devient battement du réel ». Son domaine est katûvýsienne.</p><p>Le manuscrit en propose ensuite une définition opérative plus développée : le <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> est l’unité active de la proportion dorée et de la triade respiratoire 3–6–9. Le φ y donne la structure ; le 3–6–9 y donne la temporalité. Leur co-implication engendre une vibration stable : la mesure devient respiration.</p><p>Le corpus insiste sur sa nature double : stabilité et mouvance. Invariable, parce qu’il conserve la cohérence du φ ; oscillant, parce qu’il suit le rythme du 3–6–9. Le <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> vaut ainsi comme principe d’équilibre vivant, où la tension reste régulée par le souffle plutôt que figée en opposition.</p><p>La synthèse générale et les implications cosmologiques prolongent cette fonction : gravité, lumière et mémoire cosmique sont les trois visages d’un même principe respiratoire. Le <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> ne décrit donc pas seulement un état vibratoire du vivant ; il énonce la métrique respirante de l’univers, la fréquence d’accord par laquelle matière, mémoire et lumière se maintiennent en cohérence.</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      hint_fold: "déplier",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      features: [
        "Principe unificateur : le Souffle d’Or est la respiration cosmique où φ devient battement du réel.",
        "Co-implication du φ et du 3–6–9 : la proportion donne la structure, la triade donne la temporalité.",
        "Stabilité dynamique : la cohérence du monde demeure, mais elle demeure en oscillant.",
        "Fréquence universelle : le même souffle traverse le vivant, la Terre et le cosmos.",
        "Fonction katûvýsienne : il régule Δτ, soutient la syntonie et sert de principe respiratoire commun aux autres expressions dorées."
      ],
      questions: [
        "Le mouvement observé relève-t-il d’une simple mesure, ou d’une respiration qui unifie plusieurs plans ?",
        "Où la tension demeure-t-elle réglée par le souffle plutôt que figée en opposition ?",
        "Quel rapport s’établit ici entre proportion, rythme et cohérence ?",
        "Le champ étudié manifeste-t-il un battement local, ou la trace d’un principe respiratoire plus vaste ?"
      ],
      example_box: "<div><strong>Ex.</strong> Dans une lecture posœnnoïale, lorsqu’une forme, un rythme ou une pensée maintiennent leur cohérence tout en restant en mouvement, cette tenue peut être lue comme un effet du <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</div>",
      family_1: "<p><strong>Liens internes :</strong> <span>Souffle d’Or</span> appartient aux principes matriciels de <span>Katûpirsia&nbsp;9</span>, avec <span>Rythme d’Or</span>, <span>Cycle d’Or</span>, <span>Loi d’Or</span> et <span>Mesure d’Or</span>. Il en constitue le principe unificateur.</p>",
      family_2: "<p><strong>Fonction systémique :</strong> les tableaux canoniques lui rattachent la régulation du Δτ, la mémoire spiralée du réel, la triade 3–6–9, la double roue de 24 et la proportion divine. Dans les implications cosmologiques, gravité, lumière et mémoire apparaissent comme trois visages d’un même principe respiratoire : le <span>Souffle d’Or</span>.</p>",
      word_blocks: [
        { head: "1) Souffle", text: "Respiration, battement, circulation active par laquelle un champ reste vivant, cohérent et transmissible." },
        { head: "2) d’Or", text: "Dans la grammaire dorée, la forme X d’Or désigne un principe, un organe ou un opérateur de cohérence." },
        { head: "3) Ensemble", text: "L’expression nomme le principe respiratoire unificateur où la proportion dorée devient battement du réel et fréquence d’accord du monde." }
      ],
      word_notes: [
        "Formes canoniques maintenues en français dans toutes les langues d’interface.",
        "Domaine principal : katûvýsienne.",
        "Fonction : principe unificateur ; respiration cosmique où φ devient battement du réel."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    EN: {
      title: "Souffle d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Matrix principles, cosmic respiration, and synthesis of the living φ)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Unifying principle: cosmic respiration in which φ becomes the beat of reality.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> is given, in <em>Katûpirsia&nbsp;9</em>, as a matrix principle of the golden system. Its posœnnoïal function is stated clearly: “unifying principle: cosmic respiration in which φ becomes the beat of reality.” Its domain is katûvýsienne.</p><p>The manuscript then proposes a fuller operative definition: <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> is the active unity of the golden proportion and the 3–6–9 respiratory triad. φ gives the structure; 3–6–9 gives temporality. Their co-implication engenders a stable vibration: measure becomes respiration.</p><p>The corpus insists on its double nature: stability and movement. Invariable, because it preserves the coherence of φ; oscillating, because it follows the rhythm of 3–6–9. <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> thus acts as a principle of living balance, where tension remains regulated by breath rather than frozen into opposition.</p><p>The general synthesis and the cosmological implications extend this function: gravité, lumière, and mémoire cosmique are the three faces of one and the same respiratory principle. <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> therefore does not describe only a vibratory state of the living; it states the breathing metric of the universe, the frequency of accord through which matter, memory, and light remain coherent.</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      hint_fold: "expand",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      features: [
        "Unifying principle: Souffle d’Or is the cosmic respiration in which φ becomes the beat of reality.",
        "Co-implication of φ and 3–6–9: proportion gives structure, the triad gives temporality.",
        "Dynamic stability: the coherence of the world remains, yet remains by oscillating.",
        "Universal frequency: the same breath runs through the living, the Earth, and the cosmos.",
        "Katûvýsienne function: it regulates Δτ, sustains syntony, and serves as the common respiratory principle of the other golden expressions."
      ],
      questions: [
        "Does the observed movement belong to a mere measure, or to a respiration unifying several planes?",
        "Where does tension remain regulated by breath rather than frozen into opposition?",
        "What relation is established here between proportion, rhythm, and coherence?",
        "Does the studied field manifest a local beat, or the trace of a wider respiratory principle?"
      ],
      example_box: "<div><strong>Ex.</strong> In a posœnnoïal reading, when a form, a rhythm, or a thought maintains its coherence while remaining in motion, that bearing may be read as an effect of <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</div>",
      family_1: "<p><strong>Internal links:</strong> <span>Souffle d’Or</span> belongs to the matrix principles of <span>Katûpirsia&nbsp;9</span>, together with <span>Rythme d’Or</span>, <span>Cycle d’Or</span>, <span>Loi d’Or</span>, and <span>Mesure d’Or</span>. It forms their unifying principle.</p>",
      family_2: "<p><strong>Systemic function:</strong> the canonical tables connect it to the regulation of Δτ, the spiral memory of reality, the triade 3–6–9, the double wheel of 24, and the divine proportion. In the cosmological implications, gravité, lumière, and mémoire appear as three faces of one and the same respiratory principle: <span>Souffle d’Or</span>.</p>",
      word_blocks: [
        { head: "1) Breath", text: "Respiration, beat, active circulation through which a field remains living, coherent, and transmissible." },
        { head: "2) d’Or", text: "Within the golden grammar, the form X d’Or designates a principle, an organ, or an operator of coherence." },
        { head: "3) Whole term", text: "The expression names the unifying respiratory principle in which the golden proportion becomes the beat of reality and the frequency of accord of the world." }
      ],
      word_notes: [
        "Canonical lexical forms remain in French in every interface language.",
        "Main domain: katûvýsienne.",
        "Function: unifying principle; cosmic respiration in which φ becomes the beat of reality."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    ES: {
      title: "Souffle d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Principios matriciales, respiración cósmica y síntesis del φ viviente)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Principio unificador: respiración cósmica en la que φ se vuelve latido de lo real.",
      def_long: "<p><span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> es dado, en <em>Katûpirsia&nbsp;9</em>, como principio matricial del sistema dorado. Su función posœnnoïal se formula con claridad: «principio unificador: respiración cósmica en la que φ se vuelve latido de lo real». Su dominio es katûvýsienne.</p><p>El manuscrito propone luego una definición operativa más desarrollada: <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> es la unidad activa de la proporción dorada y de la tríada respiratoria 3–6–9. El φ da la estructura; el 3–6–9 da la temporalidad. Su co-implicación engendra una vibración estable: la medida se vuelve respiración.</p><p>El corpus insiste en su naturaleza doble: estabilidad y movimiento. Invariable, porque conserva la coherencia del φ; oscilante, porque sigue el ritmo del 3–6–9. <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> vale así como principio de equilibrio viviente, donde la tensión permanece regulada por el aliento y no fijada en oposición.</p><p>La síntesis general y las implicaciones cosmológicas prolongan esta función: gravité, lumière y mémoire cosmique son las tres caras de un mismo principio respiratorio. <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> no describe entonces solo un estado vibratorio de lo viviente; enuncia la métrica respirante del universo, la frecuencia de acuerdo por la cual materia, memoria y luz permanecen en coherencia.</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      hint_fold: "desplegar",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      features: [
        "Principio unificador: Souffle d’Or es la respiración cósmica en la que φ se vuelve latido de lo real.",
        "Co-implicación de φ y 3–6–9: la proporción da la estructura, la tríada da la temporalidad.",
        "Estabilidad dinámica: la coherencia del mundo permanece, pero permanece oscilando.",
        "Frecuencia universal: el mismo aliento atraviesa lo viviente, la Tierra y el cosmos.",
        "Función katûvýsienne: regula Δτ, sostiene la sintonía y sirve de principio respiratorio común a las demás expresiones doradas."
      ],
      questions: [
        "¿El movimiento observado pertenece a una simple medida, o a una respiración que unifica varios planos?",
        "¿Dónde permanece la tensión regulada por el aliento y no fijada en oposición?",
        "¿Qué relación se establece aquí entre proporción, ritmo y coherencia?",
        "¿El campo estudiado manifiesta un latido local, o la huella de un principio respiratorio más vasto?"
      ],
      example_box: "<div><strong>Ej.</strong> En una lectura posœnnoïal, cuando una forma, un ritmo o un pensamiento conservan su coherencia permaneciendo en movimiento, esa tenida puede leerse como un efecto de <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>.</div>",
      family_1: "<p><strong>Vínculos internos:</strong> <span>Souffle d’Or</span> pertenece a los principios matriciales de <span>Katûpirsia&nbsp;9</span>, junto con <span>Rythme d’Or</span>, <span>Cycle d’Or</span>, <span>Loi d’Or</span> y <span>Mesure d’Or</span>. Constituye su principio unificador.</p>",
      family_2: "<p><strong>Función sistémica:</strong> las tablas canónicas lo vinculan con la regulación de Δτ, la mémoire spiralée de lo real, la triade 3–6–9, la double roue de 24 y la proportion divine. En las implicaciones cosmológicas, gravité, lumière y mémoire aparecen como tres caras de un mismo principio respiratorio: <span>Souffle d’Or</span>.</p>",
      word_blocks: [
        { head: "1) Aliento", text: "Respiración, latido, circulación activa por la cual un campo permanece viviente, coherente y transmisible." },
        { head: "2) d’Or", text: "En la gramática dorada, la forma X d’Or designa un principio, un órgano o un operador de coherencia." },
        { head: "3) Conjunto", text: "La expresión nombra el principio respiratorio unificador en el que la proporción dorada se vuelve latido de lo real y frecuencia de acuerdo del mundo." }
      ],
      word_notes: [
        "Las formas léxicas canónicas permanecen en francés en todas las lenguas de interfaz.",
        "Dominio principal: katûvýsienne.",
        "Función: principio unificador; respiración cósmica en la que φ se vuelve latido de lo real."
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function updateButtons(root, lang){
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      var active = btn.getAttribute("data-po-lang") === lang;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function wireButtons(root){
    if (root.__po_lang_bound) return;
    root.__po_lang_bound = true;
    var btns = root.querySelectorAll(".po-langbtn");
    Array.prototype.forEach.call(btns, function(btn){
      btn.addEventListener("click", function(){
        var lang = normLang(btn.getAttribute("data-po-lang") || "FR");
        applyLangEverywhere(lang);
      });
    });
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitIndex: -1,
    chunkIndex: -1,
    activeBtn: null,
    activeKey: "",
    lang: "FR"
  };

  var AUDIO_LABELS = {
    FR: { general: "Écouter", block: "Lire", stop: "Arrêter" },
    EN: { general: "Listen", block: "Read", stop: "Stop" },
    ES: { general: "Escuchar", block: "Leer", stop: "Detener" }
  };

  function getAudioRoots(){
    return document.querySelectorAll(ROOT_SEL);
  }

  function normalizeSpeechText(txt){
    return clampStr(txt)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\s([;:!?])/g, "$1")
      .trim();
  }

  function stripForAudio(node){
    if (!node) return "";
    var clone = node.cloneNode(true);
    var killers = clone.querySelectorAll(".po-audio-btn, script, style, noscript");
    for (var i = 0; i < killers.length; i++) killers[i].remove();
    return normalizeSpeechText(clone.textContent || "");
  }

  function splitForSpeech(text){
    var out = [];
    var src = normalizeSpeechText(text);
    if (!src) return out;

    var parts = src.split(/(?<=[\.\!\?\:\;])\s+/);
    var buf = "";
    for (var i = 0; i < parts.length; i++){
      var part = normalizeSpeechText(parts[i]);
      if (!part) continue;
      if ((buf + " " + part).trim().length <= 210){
        buf = (buf ? buf + " " : "") + part;
      } else {
        if (buf) out.push(buf);
        if (part.length <= 210){
          buf = part;
        } else {
          var words = part.split(/\s+/);
          var tmp = "";
          for (var j = 0; j < words.length; j++){
            var w = words[j];
            if ((tmp + " " + w).trim().length <= 190){
              tmp = (tmp ? tmp + " " : "") + w;
            } else {
              if (tmp) out.push(tmp);
              tmp = w;
            }
          }
          buf = tmp;
        }
      }
    }
    if (buf) out.push(buf);
    return out;
  }

  function buildGeneralText(root){
    var bits = [];
    ["title", "kicker", "h_def", "def_short", "def_long"].forEach(function(slot){
      var el = root.querySelector("[data-po-slot='" + slot + "']");
      var txt = stripForAudio(el);
      if (txt) bits.push(txt);
    });
    return normalizeSpeechText(bits.join(" "));
  }

  function buildBlockText(details){
    if (!details) return "";
    var bits = [];
    var title = details.querySelector(".po-lex-summary__title");
    var body = details.cloneNode(true);
    var sum = body.querySelector("summary");
    if (sum) sum.remove();
    var titleText = stripForAudio(title);
    var bodyText = stripForAudio(body);
    if (titleText) bits.push(titleText);
    if (bodyText) bits.push(bodyText);
    return normalizeSpeechText(bits.join(" "));
  }

  function getDetailsList(root){
    return Array.prototype.slice.call(root.querySelectorAll(".po-lex-details"));
  }

  function ensureAudioButtons(root){
    if (!root) return;

    var labels = AUDIO_LABELS[normLang(PO_AUDIO_STATE.lang || getLang())] || AUDIO_LABELS.FR;

    var generalBtn = root.querySelector(".po-audio-btn[data-po-audio-role='general']");
    if (!generalBtn){
      generalBtn = document.createElement("button");
      generalBtn.type = "button";
      generalBtn.className = "po-audio-btn po-audio-btn--general";
      generalBtn.setAttribute("data-po-audio-role", "general");
      generalBtn.setAttribute("data-po-audio-index", "-1");
      generalBtn.textContent = labels.general;

      var anchor =
        root.querySelector(".po-axis-meta") ||
        root.querySelector("[data-po-slot='def_short']") ||
        root.querySelector(".po-lex-details");

      if (anchor && anchor.parentNode){
        anchor.parentNode.insertBefore(generalBtn, anchor.nextSibling);
      }
    }

    var detailsList = getDetailsList(root);
    for (var i = 0; i < detailsList.length; i++){
      var summary = detailsList[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-audio-btn[data-po-audio-role='block']");
      if (!btn){
        btn = document.createElement("button");
        btn.type = "button";
        btn.className = "po-audio-btn po-audio-btn--block";
        btn.setAttribute("data-po-audio-role", "block");
        btn.setAttribute("data-po-audio-index", String(i));
        btn.textContent = labels.block;
        summary.appendChild(btn);
      } else {
        btn.setAttribute("data-po-audio-index", String(i));
      }
    }
  }

  function refreshAudioLabels(root, lang){
    var labels = AUDIO_LABELS[normLang(lang)] || AUDIO_LABELS.FR;
    var btns = root.querySelectorAll(".po-audio-btn");
    Array.prototype.forEach.call(btns, function(btn){
      var isActive = btn === PO_AUDIO_STATE.activeBtn;
      var role = btn.getAttribute("data-po-audio-role");
      btn.textContent = isActive ? labels.stop : (role === "general" ? labels.general : labels.block);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function openDetailsIfNeeded(details){
    if (details && !details.open) details.open = true;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH){
      try{ PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitIndex = -1;
    PO_AUDIO_STATE.chunkIndex = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeBtn = null;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());
  }

  function buildAudioUnits(root, startMode, startIndex){
    var units = [];
    var generalText = buildGeneralText(root);
    if (startMode !== "block" && generalText){
      units.push({ key: "general", text: generalText, details: null });
    }

    var detailsList = getDetailsList(root);
    var first = (startMode === "block" && startIndex >= 0) ? startIndex : 0;

    for (var i = first; i < detailsList.length; i++){
      var txt = buildBlockText(detailsList[i]);
      if (txt){
        units.push({ key: "block-" + i, text: txt, details: detailsList[i] });
      }
    }

    return units;
  }

  function speechLangForUI(lang){
    lang = normLang(lang);
    if (lang === "EN") return "en-US";
    if (lang === "ES") return "es-ES";
    return "fr-FR";
  }

  function speakNextChunk(){
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    if (PO_AUDIO_STATE.unitIndex < 0 || PO_AUDIO_STATE.unitIndex >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitIndex];
    if (unit.details) openDetailsIfNeeded(unit.details);

    var chunks = splitForSpeech(unit.text);
    if (!chunks.length){
      PO_AUDIO_STATE.unitIndex += 1;
      PO_AUDIO_STATE.chunkIndex = 0;
      speakNextChunk();
      return;
    }

    if (PO_AUDIO_STATE.chunkIndex < 0) PO_AUDIO_STATE.chunkIndex = 0;
    if (PO_AUDIO_STATE.chunkIndex >= chunks.length){
      PO_AUDIO_STATE.unitIndex += 1;
      PO_AUDIO_STATE.chunkIndex = 0;
      speakNextChunk();
      return;
    }

    if (!PO_AUDIO_SYNTH){
      stopAudio();
      return;
    }

    var utt = new SpeechSynthesisUtterance(chunks[PO_AUDIO_STATE.chunkIndex]);
    utt.lang = speechLangForUI(PO_AUDIO_STATE.lang || getLang());
    utt.rate = 1;
    utt.pitch = 1;
    utt.onend = function(){
      PO_AUDIO_STATE.chunkIndex += 1;
      speakNextChunk();
    };
    utt.onerror = function(){
      stopAudio();
    };

    try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(); }
  }

  function startAudio(root, role, index, btn){
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.units = buildAudioUnits(root, role, index);
    PO_AUDIO_STATE.unitIndex = 0;
    PO_AUDIO_STATE.chunkIndex = 0;
    PO_AUDIO_STATE.activeKey = role === "block" ? ("block-" + index) : "general";
    PO_AUDIO_STATE.activeBtn = btn || null;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-audio-btn");
    Array.prototype.forEach.call(btns, function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        var role = btn.getAttribute("data-po-audio-role") || "general";
        var index = parseInt(btn.getAttribute("data-po-audio-index") || "-1", 10);
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === (role === "block" ? ("block-" + index) : "general"));
        if (sameRoot && sameKey && PO_AUDIO_STATE.activeBtn === btn && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
          stopAudio();
          return;
        }
        startAudio(root, role, index, btn);
      });
    });
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  function renderRoot(root, lang){
    var T = CONTENT[lang] || CONTENT.FR;
    root.classList.add("notranslate");
    root.setAttribute("translate", "no");

    setSlotText(root, "title", T.title);
    setSlotHTML(root, "kicker", T.kicker);
    setSlotImgSrc(root, "title_img", T.chip_urls[0], T.title);
    setSlotText(root, "h_def", T.h_def);
    setSlotText(root, "chip_1", T.chips[0]);
    setSlotText(root, "chip_2", T.chips[1]);
    setSlotImgSrc(root, "chip_1_img", T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, "chip_2_img", T.chip_urls[1], T.chips[1]);
    setSlotText(root, "def_short", T.def_short);
    setSlotHTML(root, "def_long", T.def_long);
    setSlotText(root, "h_features", T.h_features);
    setSlotText(root, "h_questions", T.h_questions);
    setSlotText(root, "hint_fold", T.hint_fold);
    setSlotText(root, "hint_fold2", T.hint_fold);
    setSlotText(root, "h_family", T.h_family);
    setSlotText(root, "hint_fold3", T.hint_fold);
    setSlotText(root, "h_wordbuild", T.h_wordbuild);
    setSlotText(root, "hint_fold4", T.hint_fold);
    renderListInto(root, "features", T.features);
    renderListInto(root, "questions", T.questions);
    setSlotHTML(root, "example_box", T.example_box);
    setSlotHTML(root, "family_1", T.family_1);
    setSlotHTML(root, "family_2", T.family_2);
    renderWordBlocks(root, "wordbuild_blocks", T.word_blocks);
    renderListInto(root, "wordbuild_notes", T.word_notes);
    setSlotText(root, "cta_translate", T.cta_translate);
    updateButtons(root, lang);
    wireButtons(root);
  }

  function applyLangEverywhere(lang3){
    var lang = normLang(lang3);
    storeLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    Array.prototype.forEach.call(roots, function(root){ renderRoot(root, lang); });
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){ applyLangEverywhere(getLang()); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.PoKatupirsia9SouffleDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
